import React from "react";
import Select from "react-select";
import {
  customSelectStyles,
  getOrganizationId,
} from "../../../../../Utils/CommonUtils";
import { getUserOrgMapping } from "../UserService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setPspMappingData } from "../../../../../slices/team/users/usersSlice";

const SelectDropdownPspMapping = ({ selectedRows }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.users.selectedUser.detailsData);
  const pspMappingData = useSelector(
    (state) => state.users.selectedUser.pspMappingData
  );
  const ownerId = getOrganizationId();
  const selectOptions = [
    { label: "Linked", value: "linked", action_flag: 1 },
    { label: "Unlinked", value: "unlinked", action_flag: 0 },
  ];

  const handleStatusChange = (selectedOption) => {
    if (
      !pspMappingData ||
      pspMappingData.length === 0 ||
      !selectedRows ||
      selectedRows.length === 0
    ) {
      return;
    }

    // Filter pspMappingData based on selectedRows
    const updatedEntities = pspMappingData
      .filter((row) => selectedRows.includes(row.entityid))
      .map((row) => ({
        ...row,
        linked_status: selectedOption.value,
      }));

    // Extract entity_ids from updatedEntities
    const entityIdsToUpdate = updatedEntities.map((entity) => entity.entityid);
    const action_flag =
      selectOptions.find((option) => option.value === selectedOption.value)
        ?.action_flag ?? 0;

    // Call getUserOrgMapping with entityIdsToUpdate
    // dispatch(setPspMappingData(updatedEntities));
    getUserOrgMapping(
      entityIdsToUpdate,
      "PSP",
      data.user_id,
      action_flag,
      setPspMappingData
    );
  };

  return (
    <Select
      placeholder="Link"
      name="name"
      options={selectOptions}
      styles={customSelectStyles}
      onChange={handleStatusChange}
      menuPortalTarget={document.body}
      // value={
      //   selectOptions?.filter(
      //     (itm) => itm?.value === filterForm?.name
      //   ) || ""
      // }
      required
      // onChange={(e) =>
      //   dispatch(
      //     setMerchantFilterForm({
      //       name: "name",
      //       value: e.value,
      //     })
      //   )
      // }
    />
  );
};

export default SelectDropdownPspMapping;
